import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()
import { closest } from '~/common/utils'

const HEADER = 'header'
const MORE_ITEM = '.js-more-item'
const MORE_TRIGGER = '.js-more-trigger'
const CLEAR_TRIGGER = '.js-clear-trigger'
const COUNT_MEMBER = '.js-count-member'
const COUNT_MULTIPLICATION = '.js-count-multiplication'
const CLASS_HIDDEN = '-hidden'

/**
 * @export
 * @class MoreList
 */
export default class MoreList {

  /**
   * @param { number } item
   */
  constructor(item) {
    this.header = document.getElementById(HEADER)
    this.moreItems = document.querySelectorAll(MORE_ITEM)
    this.moreTrigger = document.querySelector(MORE_TRIGGER)
    this.clearTrigger = document.querySelectorAll(CLEAR_TRIGGER)
    this.countMember = document.querySelectorAll(COUNT_MEMBER)
    this.countMultiplication = document.querySelectorAll(COUNT_MULTIPLICATION)

    // リストの数が設定したものより少ない場合は初期表示の数を変更する
    this.itemNumber = this.moreItems.length < item ? 1 : item
    item = parseInt(this.itemNumber)
    this.itemCounter = item

    if (this.moreTrigger !== null) this.init(item)
  }

  init(item) {
    if (this.moreItems.length >= item) {
      // 初期表示
      ;[...this.moreItems].slice(0, item).map(el => {
        el.classList.remove(CLASS_HIDDEN)
      })

      this.moreTrigger.addEventListener('click', el => {
        el.preventDefault()
        this.show(el)
      })

      ;[...this.clearTrigger].map(el => {
        el.addEventListener('click', _el => {
          _el.preventDefault()
          this.hide(_el)
        })
      })
    }

    // ボタン表示
    if (this.moreItems.length > item) this.moreTrigger.setAttribute('style', 'display: block;')
  }

  show(el) {
    el = el.currentTarget
    this.itemCounter += 1

    if (this.moreItems.length < this.itemCounter) return

    this.moreItems[this.itemCounter - 1].classList.remove(CLASS_HIDDEN)
    const offsetTop = window.pageYOffset
    const headerHeight = this.header.clientHeight
    const top = offsetTop + this.moreItems[this.itemCounter - 1].getBoundingClientRect().top - headerHeight

    if (!el.classList.contains('no-scrollTo')) {
      setTimeout(() => {
        window.scrollTo({
          top,
          behavior: 'smooth'
        })
      }, 10)
    }

    // 次に表示するリストがない場合はボタンを非表示にする
    if (![...this.moreItems].slice(-1)[0].classList.contains(CLASS_HIDDEN)) this.moreTrigger.setAttribute('style', 'display: none;')
  }

  hide(el) {
    this.itemCounter -= 1
    // 次に表示するリストがある場合は追加ボタン表示する
    if ([...this.moreItems].slice(-1)[0].classList.contains(CLASS_HIDDEN)) this.moreTrigger.setAttribute('style', 'display: block;')
  }
}